import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="set-meeting-host"
export default class extends Controller {
  connect() {
    const zoomMeetingLinks = document.querySelectorAll('a.zoom-meeting-link');
    zoomMeetingLinks.forEach(link => {
      link.addEventListener('click', function() {
        const headers = new Headers()
        headers.append('Content-Type', 'application/json')
        const csrf = document.querySelector('[name="csrf-token"]')
        if (csrf) {
          headers.append('X-CSRF-Token', document.querySelector('[name="csrf-token"]').content)
        }
        const path =link.dataset.path;
        fetch(`${path}`, {
          method: 'PUT',
          headers: headers
        })
      });
    });

  }
}
